export const ManualCreationEntitiesEnum = {
	Investment: "INVESTMENT",
	Universe: "UNIVERSE",
	InvestmentDraft: "INVESTMENT_DRAFT",
	Reference: "REFERENCE",
} as const;

export type ManualCreationEntitiesEnum = (typeof ManualCreationEntitiesEnum)[keyof typeof ManualCreationEntitiesEnum];

export const ManualEditEntitiesEnum = {
	Investment: "INVESTMENT",
	Universe: "UNIVERSE",
	InvestmentDraft: "INVESTMENT_DRAFT",
	Benchmark: "BENCHMARK",
	Reference: "REFERENCE",
	InvestmentEnhancement: "INVESTMENT_ENHANCEMENT",
} as const;

export type ManualEditEntitiesEnum = (typeof ManualEditEntitiesEnum)[keyof typeof ManualEditEntitiesEnum];
